import React from "react";
import { useTabs } from "../../hooks/lib/useTabs";
import { useMobile } from "../../hooks/custom/useMobile";
import { IChancellorMessageData } from "../../exports/interfaces";

export const Message = (props: {
  chancellorMessage: IChancellorMessageData[];
  viceChancellorMessage: IChancellorMessageData[];
}) => {
  useTabs();

  const isMobile = useMobile();

  return (
    <section>
      <div className="td_height_120 td_height_lg_40" />
      <div className="container">
        <div
          className="td_section_heading td_style_1 text-center wow fadeInUp"
          data-wow-duration="1s"
          data-wow-delay="0.15s"
        >
          <p
            className="td_section_subtitle_up td_fs_18 td_semibold td_spacing_1 td_mb_10 text-uppercase td_accent_color"
            style={{ textAlign: "unset" }}
          >
            WELCOME
          </p>
          <h2 className="td_section_title td_fs_48 mb-0">Message From Desk</h2>
          <div className="td_height_30 td_height_lg_30" />
        </div>
        <div className="row td_gap_y_50">
          {/* content */}
          <div className="td_course_details">
            {/* tabs */}
            <div className="td_message_tabs td_style_1 td_mb_50">
              <ul className="td_tab_links td_style_2 td_type_2 td_mp_0 td_medium td_fs_20 td_heading_color">
                <li className="active">
                  <a href="#td_message_tab_1">Chancellor</a>
                </li>
                <li>
                  <a href="#td_message_tab_2">Vice Chancellor</a>
                </li>
                {/* <li>
                  <a href="#td_tab_3">Registrar</a>
                </li> */}
              </ul>
              <div className="td_tab_body td_fs_18">
                <div className="td_tab active" id="td_message_tab_1">
                  <div
                    style={{
                      display: "flex",
                      gap: "25px",
                      flexDirection: isMobile ? "column" : "row",
                    }}
                  >
                    <div>
                      <img
                        src={`${process.env.REACT_APP_cmsUrl}${props?.chancellorMessage[0]?.image[0]?.media?.url}`}
                        alt="Chancellor"
                        height="auto"
                        width="1500px"
                      />
                    </div>
                    <p className="mb-0 custom-text-p">
                      <div
                        dangerouslySetInnerHTML={{
                          __html: props?.chancellorMessage[0]?.message,
                        }}
                      />

                      <p>
                        With gratitude and enthusiasm,
                        <br />
                        <strong>{props?.chancellorMessage[0]?.name}</strong>
                        <br />
                        <strong>Chancellor</strong>
                        <br />
                        <strong>University of Nepal</strong>
                      </p>
                    </p>
                  </div>
                </div>
                <div className="td_tab" id="td_message_tab_2">
                  <div
                    style={{
                      display: "flex",
                      gap: "25px",
                      flexDirection: isMobile ? "column" : "row",
                    }}
                  >
                    <div>
                      <img
                        src={`${process.env.REACT_APP_cmsUrl}${props?.viceChancellorMessage[0]?.image[0]?.media?.url}`}
                        alt="Vice Chancellor"
                        height="auto"
                        width="1500px"
                      />
                    </div>
                    <p className="mb-0">
                      <div
                        dangerouslySetInnerHTML={{
                          __html: props?.viceChancellorMessage[0]?.message,
                        }}
                      />

                      <p>
                        With gratitude and enthusiasm,
                        <br />
                        <strong>{props?.viceChancellorMessage[0]?.name}</strong>
                        <br />
                        <strong>Vice Chancellor</strong>
                        <br />
                        <strong>University of Nepal</strong>
                      </p>
                    </p>
                  </div>
                </div>
                <div className="td_tab" id="td_tab_3">
                  <p className="mb-0"></p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
